import script from "./ChatHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatHistory.vue?vue&type=script&setup=true&lang=js"

import "./ChatHistory.vue?vue&type=style&index=0&id=2b1c37ad&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b1c37ad"]])

export default __exports__